import { Component, OnInit, inject } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { BaseFormComponent, BaseRendererComponent, FormService, ModalService } from 'tms-lib';
import { Product, TmsFormlyService } from 'tms-web-shared';

@Component({
  selector: 'app-product-search-renderer',
  templateUrl: './product-search-renderer.component.html',
  styleUrl: './product-search-renderer.component.scss',
  imports: [BaseFormComponent],
})
export class ProductSearchRendererComponent extends BaseRendererComponent implements OnInit {
  private readonly formlyService = inject(TmsFormlyService);
  private readonly formService = inject(FormService);
  private readonly modalService = inject(ModalService);

  protected fields: FormlyFieldConfig[];
  private modalLevel: number;

  ngOnInit(): void {
    this.getFields();
    this.modalLevel = this.modalService.modalLevel;
  }

  get show(): boolean {
    return !this.isAggregate && (!this.params.show || this.params.show(this.rowData));
  }

  private getFields() {
    this.fields = [
      ...this.formlyService
        .productSearch(
          'productSearch',
          'productId',
          (model: Product) => this.changeProduct(model),
          () => this.clearProduct(),
          { required: true, hideLabel: true },
        )
        .map((field) => ({ ...field, wrappers: ['inline'] })),
    ];
  }

  private changeProduct(product: Product) {
    this.rowData.productId = product.id;
    this.setDataValue('productKey', product.key);
    this.setDataValue('productDescription', product.description);
    this.setDataValue('productTypeDescription', product.productType);
    if (this.params.selected) {
      this.params
        .selected(this.rowData)
        .pipe(this.untilDestroyed())
        .subscribe(() => this.formService.resetForms(this.modalLevel));
    }
  }

  private clearProduct() {
    this.rowData.productId = undefined;
    this.setDataValue('productKey', undefined);
    this.setDataValue('productDescription', undefined);
    this.setDataValue('productTypeDescription', undefined);
  }
}
